module.exports = __webpack_public_path__ + "static/media/background2.19e8620a.png";